(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); this.setHeaderHeight = this.setHeaderHeight.bind(this); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    createObserver() { let observer = new IntersectionObserver((entries, observer) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); }); observer.observe(this.header); }
    onScroll() { const scrollTop = window.pageYOffset || document.documentElement.scrollTop; if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) { this.header.classList.add('scrolled-past-header'); } else if (scrollTop <= this.headerBounds.top) { this.header.classList.remove('scrolled-past-header'); } this.currentScrollTop = scrollTop; }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
